import { CacheStrategy } from '@rammetec/data-access';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { WORK_CALENDAR_EXCEPTION, WorkCalendarExceptionKindValues, WORK_CALENDAR_EXCEPTION_KIND_LABELS, } from '../types/work-calendar-exception.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for WorkCalendarException (one-day override of a WorkCalendar).
 * Subcollection: org/{orgId}/work-calendar/{workCalendarId}/exception
 *
 * Resolve repository with context: { orgId, workCalendarId }.
 * No lifecycle / audit — same discipline as SizeOccurrence.
 */
export const workCalendarExceptionDescriptor = {
    name: WORK_CALENDAR_EXCEPTION,
    label: 'Exceção de calendário',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/work-calendar/{workCalendarId}/exception',
    pathPatternKeys: {
        orgId: 'string',
        workCalendarId: 'string',
    },
    version: 1,
    description: 'One-day exception of a WorkCalendar (nonworking holiday or extra working window)',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique exception identifier',
        },
        {
            name: 'date',
            label: 'Data',
            type: 'date',
            required: true,
            description: 'Operational business day stored as UTC-midnight. Compare by Y/M/D in UTC.',
        },
        {
            name: 'kind',
            label: 'Tipo',
            type: 'enum',
            required: true,
            enumValues: [...WorkCalendarExceptionKindValues],
            enumLabels: WORK_CALENDAR_EXCEPTION_KIND_LABELS,
            description: 'nonworking = closed day; working = replaces the weekly pattern with this window',
        },
        {
            name: 'description',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Human label (e.g. Natal, Sábado extra)',
        },
        {
            name: 'startMinuteOfDay',
            label: 'Início',
            type: 'number',
            required: false,
            description: 'Required when kind = working. Wall-clock minute of day (0..1439).',
        },
        {
            name: 'durationMs',
            label: 'Duração',
            type: 'number',
            required: false,
            description: 'Required when kind = working. Duration in milliseconds, 1..86_400_000.',
        },
    ],
};
//# sourceMappingURL=work-calendar-exception.descriptor.js.map